import { render, staticRenderFns } from "./myReturn.vue?vue&type=template&id=7994dc0f&scoped=true"
import script from "./myReturn.vue?vue&type=script&lang=js"
export * from "./myReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7994dc0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7994dc0f')) {
      api.createRecord('7994dc0f', component.options)
    } else {
      api.reload('7994dc0f', component.options)
    }
    module.hot.accept("./myReturn.vue?vue&type=template&id=7994dc0f&scoped=true", function () {
      api.rerender('7994dc0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wovenBagManagement/detailManagement/cmp/myReturn.vue"
export default component.exports